"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indentIfBreak = exports.ifBreak = exports.dedent = exports.indent = exports.fill = exports.group = exports.join = exports.concat = void 0;
var prettier = require("prettier").doc.builders;
var processComments = require("./comments/format-comments").processComments;
/*
 * ------------------------------------------------------------------
 * Wraps the Prettier builder functions to print tokens with comments
 * ------------------------------------------------------------------
 */
function concat(docs) {
    var concatenation = processComments(docs);
    if (!Array.isArray(docs)) {
        return "";
    }
    return concatenation;
}
exports.concat = concat;
function join(sep, docs) {
    var concatenation = prettier.join(processComments(sep), processComments(docs));
    return processEmptyDocs(concatenation);
}
exports.join = join;
function group(doc, opts) {
    var group = prettier.group(processComments(doc), opts);
    return group.contents === undefined ? "" : group;
}
exports.group = group;
function fill(docs) {
    var fill = prettier.fill(processComments(docs));
    return processEmptyDocs(fill);
}
exports.fill = fill;
function indent(doc) {
    var indentedDoc = prettier.indent(processComments(doc));
    return indentedDoc.contents.length === 0 ? "" : indentedDoc;
}
exports.indent = indent;
function dedent(doc) {
    var indentedDoc = prettier.dedent(processComments(doc));
    return indentedDoc.contents.length === 0 ? "" : indentedDoc;
}
exports.dedent = dedent;
function ifBreak(breakContents, flatContents) {
    return prettier.ifBreak(processComments(breakContents), processComments(flatContents));
}
exports.ifBreak = ifBreak;
function indentIfBreak(contents, opts) {
    return prettier.indentIfBreak(processComments(contents), opts);
}
exports.indentIfBreak = indentIfBreak;
// TODO: remove this once prettier 3.0 is released
var processEmptyDocs = function (doc) {
    var _a;
    return ((_a = doc.parts) === null || _a === void 0 ? void 0 : _a.length) === 0 ? "" : doc;
};
